<template>
  <div class="how-to-play container-custom">
    <div class="how-to-play__header">
      <div class="how-to-play__header__title">
        HOW TO PLAY
      </div>
      <div class="how-to-play__header__des">
        With coverage of 160+ Lucky Numbers games, we will show you how to quickly start playing so that you don't miss out.
      </div>
    </div>
    <div class="how-to-play__content">
      <div class="how-to-play__content__image">
        <img src="@/assets/images/how-to-play/wsb-howtoplay-images-01.jpg"/>
      </div>
      <div class="how-to-play__content__des">
        <div class="how-to-play__content__des__title">
          SELECT YOUR GAME
        </div>
        <p class="how-to-play__content__des__item">
          To begin wagering select your prefered Lucky Numbers game by clicking on the "BET" button.
        </p>
        <p class="how-to-play__content__des__item">
          Choose from our extensive list of international Lucky Numbers draws by searching available draws on the Lucky Numbers page or find the most recent upcoming draws on the home page carousel.
        </p>
        <p class="how-to-play__content__des__item">
          Numerous Lucky Numbers draws take place regularly offering you the chance to win every day of the week.
        </p>
        <p class="how-to-play__content__des__item">
          Once you have selected the Lucky Numbers you will be provided with betting market types available for your selected game.
        </p>
      </div>
    </div>
    <div class="how-to-play__content">
      <div class="how-to-play__content__des">
        <div class="how-to-play__content__des__title">
          SELECT YOUR MARKET
        </div>
        <p class="how-to-play__content__des__item">
          Varying selection ranges, above or below predicted sums and odd or even options are easy and quick to choose.
        </p>
        <p class="how-to-play__content__des__item">
          On completion of choosing your market, your wager will be added to the betslip. Finalise your wager by selecting the “BET” button.
        </p>
        <p class="how-to-play__content__des__item">
          By selecting the Regular Draw option you can choose your own numbers. If your pick matches the Lucky Numbers results exactly you will win your wager. The prize will be the multiple of the stake and the odds within the wagered market.
        </p>
        <p class="how-to-play__content__des__item">
          Other markets types, such as Draw Sum, allow wagering on the outcome of Lucky Numbers e.g. whether, for a particular draw, the sum of balls drawn will be odd or even. Remember, there can be only one unique bet per outcome, per wager, for the side markets.
        </p>
      </div>
      <div class="how-to-play__content__image">
        <img src="@/assets/images/how-to-play/wsb-howtoplay-images-02.jpg"/>
      </div>
    </div>
    <div class="how-to-play__content">
      <div class="how-to-play__content__image">
        <img src="@/assets/images/how-to-play/wsb-howtoplay-images-03.jpg"/>
      </div>
      <div class="how-to-play__content__des">
        <div class="how-to-play__content__des__title">
          MAKE YOUR WAGER
        </div>
        <p class="how-to-play__content__des__item">
          You may wager on multiple draws by changing the draws option. The draws available are limited to draws within a week period. Rapid Lucky Numbers, which occur in a very short space of time, will have a maximum of 10 draws available.
        </p>
        <p class="how-to-play__content__des__item">
          Similarly, you can change your stake per wager.
        </p>
        <p class="how-to-play__content__des__item">
          Each wager entry will display the possible winnings for all your selected draws. This amount is the total sum of all your wagers as if you had won every wager.
        </p>
        <p class="how-to-play__content__des__item">
          Once you have verified your wager information, complete your transaction by pressing the "BET" button.
        </p>
      </div>
    </div>
    <div class="how-to-play__content">
      <div class="how-to-play__content__des">
        <div class="how-to-play__content__des__title">
          VIEW YOUR WAGERS
        </div>
        <p class="how-to-play__content__des__item">
          The wager page will summarise all transactions with the date, description, status, total stake and total payouts made.
        </p>
        <p class="how-to-play__content__des__item">
          In addition, we provide a full breakdown of your wager in the wager details section including important information such as transaction date, Lucky Numbers details, wager stake, odds, Lucky Numbers results, draw ID, wagered market type and payouts.
        </p>
      </div>
      <div class="how-to-play__content__image">
        <img src="@/assets/images/how-to-play/wsb-howtoplay-images-04.jpg"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
}
</script>
<style scoped lang="scss" src="@/assets/scss/how-to-play/how-to-play.scss"/>
